import { render, staticRenderFns } from "./spaceData.vue?vue&type=template&id=00a6f2d4&scoped=true&"
import script from "./spaceData.vue?vue&type=script&lang=js&"
export * from "./spaceData.vue?vue&type=script&lang=js&"
import style0 from "./spaceData.vue?vue&type=style&index=0&id=00a6f2d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a6f2d4",
  null
  
)

export default component.exports